import { useState } from "react";

import { InputAdornment, IconButton } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";

import { TextField } from "@aclymatepackages/atoms";

import { useCachedFirebaseCrud } from "../../../helpers/firebase";

const EditableNameInput = ({
  name,
  editName,
  collection,
  id,
  onNameSave,
  helperText,
}) => {
  const { updateCollectionDoc } = useCachedFirebaseCrud();

  const [objectName, setObjectName] = useState(name || "");

  const onSaveName = () => {
    if (editName) {
      editName(objectName);
    }

    if (onNameSave) {
      onNameSave(objectName);
    }

    return updateCollectionDoc(collection, id, { name: objectName });
  };

  const onNameEnterPress = ({ key }) => {
    if (key === "Enter" && name) {
      return onSaveName();
    }
  };

  const adornmentProps =
    objectName !== name
      ? {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton size="small" onClick={onSaveName}>
                <SaveIcon />
              </IconButton>
            </InputAdornment>
          ),
        }
      : {};

  return (
    <TextField
      variant="standard"
      value={objectName}
      setValue={editName || setObjectName}
      InputProps={{
        style: { fontSize: "1rem", fontWeight: 400 },
        ...adornmentProps,
      }}
      onKeyUp={onNameEnterPress}
      helperText={helperText}
    />
  );
};
export default EditableNameInput;
